// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { ActiveStatus } from './active-status';
import { ProductFeatureChoice } from './product-feature-choice';
import { ProductType } from './product-type';
import { ProductTypeConfigProduct } from './product-type-config-product';
import { StockCondition } from './stock-condition';
import { ActiveStatusEnum } from './enums';
import { StockConditionEnum } from './enums';

/// <code-import> Place custom imports between <code-import> tags
import * as _ from 'lodash';
import { FeatureChoice } from './feature-choice';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Product extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  getStatusParents() {
    return [this.productType, this.getWorkingFeatureChoiceStatus()];
  }

  getStatusId() {
    return this.activeStatusId;
  }

  // returns the sort order of this product within others of the same type
  // requires that productType.productTypeFeatures.featureChoice have all been fetched.
  getSortOrder() {
    const pt = this.productType;
    if (pt == null) return 0;
    // find ptf with lowest display order
    const ptf = _.first(_.sortBy(pt.productTypeFeatures, (ptf) => ptf.displayOrder));
    // find featureChoice for this feature
    const pfc = this.productFeatureChoices.find((pfc) => pfc.featureChoice.featureId == ptf?.featureId);
    // this is the feature ww will sort on.
    // TODO: later we can add multi-feature sort - instead of just first feature sort.
    return pfc?.featureChoice.displayOrder;
  }

  // requires that productType.productTypeFeatures have been queried
  getOrderedProductFeatureChoices() {
    const featureIdOrder = _.orderBy(this.productType.productTypeFeatures, (x) => x.displayOrder).map((x) => x.featureId);
    const r = _.orderBy(this.productFeatureChoices, (x) => featureIdOrder.indexOf(x.featureChoice.featureId));
    return r;
  }

  getWorkingFeatureChoiceStatus(): FeatureChoice | null {
    if (!this.productFeatureChoices || this.productFeatureChoices.length == 0) return null;
    if (this.productFeatureChoices.length === 1) return this.productFeatureChoices[0].featureChoice;
    let selected = this.productFeatureChoices[0].featureChoice;
    this.productFeatureChoices.forEach((pfc) => {
      if (pfc.featureChoice.activeStatusId > selected.activeStatusId) {
        selected = pfc.featureChoice;
      }
    });
    return selected;
  }

  /**
   * Gatekeeper L1: whether a shopper may order this product now. The product, its style, and every
   * choice and feature it carries must be Active. Phaseout means submitted orders finish and no new
   * ones start; Hold and Inactive are not orderable either. A part that is not loaded is not judged
   * here: the server's ProductOrderGate is the authority.
   */
  isOrderable(): boolean {
    if (this.activeStatusId !== ActiveStatusEnum.Active) return false;
    if (this.productType && this.productType.activeStatusId !== ActiveStatusEnum.Active) return false;
    return (this.productFeatureChoices ?? []).every((pfc) => {
      const fc = pfc.featureChoice;
      if (fc == null) return true;
      return fc.activeStatusId === ActiveStatusEnum.Active && (fc.feature == null || fc.feature.activeStatusId === ActiveStatusEnum.Active);
    });
  }

  get hasStatusViolation(): boolean {
    const result =
      this.activeStatusId > ActiveStatusEnum.Active ||
      this.productType?.activeStatusId > ActiveStatusEnum.Active ||
      this.getWorkingFeatureChoiceStatus()!.activeStatusId > ActiveStatusEnum.Active;
    return result;
  }

  getAllFeatureChoices() {
    return this.getOrderedProductFeatureChoices()
      .map((pfc) => pfc.featureChoice.feature.getDisplayName() + ': ' + pfc.featureChoice.validValue)
      .join(', ');
  }
  /// </code>

  // Generated code. Do not place code below this line.
  /** Guid key */
  id!: string;
  /** Enum FK activeStatus */
  activeStatusId!: ActiveStatusEnum;
  /** String(200) */
  apiLink?: string;
  /** String(200) */
  apiLinkHint?: string;
  /** String */
  description?: string;
  /** Int32 */
  leadTimeDays!: number;
  /** Guid FK productType */
  productTypeId!: string;
  /** Binary */
  rowVersion!: any;
  /** Enum FK stockCondition */
  stockConditionId!: StockConditionEnum;
  /** FK activeStatusId */
  activeStatus!: ActiveStatus;
  /** Inv FK productId */
  productFeatureChoices!: ProductFeatureChoice[];
  /** FK productTypeId */
  productType!: ProductType;
  /** Inv FK productId */
  productTypeConfigProducts!: ProductTypeConfigProduct[];
  /** FK stockConditionId */
  stockCondition!: StockCondition;
}

